import type { ReactNode } from 'react';
import { PublicShell } from '../public/PublicShell';
import './trace-import.css';

/** The initial import view shares the public site's light presentation. */
export function TraceImport({ busy, message, error, onFile, children, accept = '.fit,.gpx,.tcx' }: {
  busy: boolean; message: string; error: boolean; onFile: (file: File) => void; children: ReactNode; accept?: string;
}) {
  return <PublicShell><section className="trace-import" data-theme="light" aria-busy={busy}
    onDragOver={event => event.preventDefault()} onDrop={event => {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file && !busy) onFile(file);
    }}>
    {children}
    <span className="eyebrow">Your trace</span>
    <h1>Open a trace file</h1>
    <p>Explore your route, choose its map and camera platform, then submit a video for processing.</p>
    <label className={`site-button trace-import-file${busy ? ' is-busy' : ''}`}>Choose trace file
      <input type="file" accept={accept} aria-label="Choose trace file" disabled={busy}
        onChange={event => {
          const file = event.currentTarget.files?.[0];
          event.currentTarget.value = '';
          if (file && !busy) onFile(file);
        }} />
    </label>
    <p>Or drop a FIT or GPX file here.</p>
    <p className="trace-import-help">Your trace is read on this device. Maps require an internet connection.</p>
    <p className="trace-import-help">Reopen the same recording to restore its Studio settings.</p>
    <p className={error ? 'trace-import-error' : 'trace-import-help'} role={error ? 'alert' : 'status'}>{message}</p>
  </section></PublicShell>;
}
